import client from './client'

export default class NPSService {

  info (flowId) {
    let url = '/api/info/' + flowId + '/'
    let data = {}
    return client.post(url, data)
  }

  store (npsId, flowId, fieldId, score, more, option, text) {
    let url = '/api/store/' + npsId + '/' + flowId + '/' + fieldId + '/'
    let data = {
      more: more
    }
    if (score != null) {
      data.score = score
    }
    if (option != null) {
      data.option = option
    }
    if (text != null) {
      data.text = text
    }
    return client.post(url, data)
  }

  finished (flowId) {
    let url = '/api/finish/' + flowId + '/'
    let data = {}
    return client.post(url, data)
  }

}
